import { memo } from "react"
import close_Image from "../../../../../../assets/games/AnimalSorat/close_Image.webp"
import jogoDoBichoTitle from "../../../../../../assets/games/AnimalSorat/Title.png"

const AllAnimals = ["TOTAIS", "PYTHON", "ELEPHANT", "DEER", "PIG", "EAGLE", "MEERKAT", "TIGER", "GIANT PANDA", "OWL", "PARROT", "MONKEY", "LION", "TOUCAN", "RABIT", "KING KONG", "CHEETAH", "RAM", "HEN", "DOG", "HORSE", "RHINOCEROS", "FOX", "DUCK", "SNAIL"]

const AnimalSoratGameOptions = memo((props) => {
    const formatRangeNumber = (num) => num === 100 ? '00' : String(num).padStart(2, '0');

    return <div id="AnimalSoratGameOptions">
        <div className="AnimalSoratGameOptionsBox">
            <img src={jogoDoBichoTitle} className="AS_gameOptions_Title" alt="" />
            <img src={close_Image} className="AS_gameOptions_closeBtn" onClick={props.closeGameRules} alt="" />
            <div className="AS_gameRules_limits">
                <div className="AS_limits_box">
                    <h2 className="AS_box_headers">LIMITS</h2>
                    <div className="AS_limits">
                        <p className="AS_limitValues">Animal: {props.as_innerLimits.split("|")[1]}</p>
                        <p className="AS_limitValues">Number: {props.as_innerLimits.split("|")[0]}</p>
                        <p className="AS_limitValues">Minimum Bet: {props.minBetAmt}</p>
                        <p className="AS_limitValues">Maximum Bet: {props.maxBetAmt}</p>
                    </div>
                </div>
                <hr className="as_hr_line" />
                <div className="AS_gameRules_payout">
                    <h2 className="AS_box_headers">Jogo DO Bicho</h2>
                    <ul className="AS_game_description">
                        <li>
                            Jogo do Bicho is a classic-style prediction and betting game where players choose from 25 unique Animals or 100 individual Numbers to try their luck. Each animal represents a group of four consecutive numbers, creating multiple ways to win. After bets are placed, a single number between 1 and 100 is drawn as the game result.
                        </li>
                        <li>
                            If the winning number matches your selected number or falls within the number range of your chosen animal, you win according to the official payout table.
                        </li>
                        <li>
                            Designed for simplicity and fun, Jogo do Bicho offers quick rounds, exciting choices, and a blend of luck and anticipation. Whether you prefer betting on your favorite animal or testing your luck with a specific number, every round delivers an engaging and entertaining gaming experience
                        </li>
                    </ul>
                    <hr className="as_hr_line" />
                    <h2 className="AS_box_headers">How To Play?</h2>
                    <div className="AS_gameRules">
                        <div className="as_rules">
                            <p>You must place at least one of the following:</p>
                            <div>
                                <h6>A. Bet on an Animal:</h6>
                                <p>Pick any of the 25 animals.
                                    If the winning number falls within that animal’s 4-number range, you win.</p>
                            </div>
                            <div>
                                <h6>B. Bet on a Number:</h6>
                                <p>Choose any number from 1 to 100.
                                    If the result is exactly that number, you win.</p>
                            </div>
                        </div>
                        <hr className="as_hr_line" />
                        <h2 className="AS_box_headers">Animal Groups & Their Numbers</h2>
                        <p>Each of the 25 animals represents a group of 4 numbers:</p>
                        <table className="animalGroup">
                            <thead className="animalNumberGroupHead">
                                <tr>
                                    <th>No</th>
                                    <th>Animal</th>
                                    <th>Numbers</th>
                                </tr>
                            </thead>
                            <tbody>
                                {AllAnimals.map((animal, idx) => <tr>
                                    <td>{idx + 1}</td>
                                    <td>{animal}</td>
                                    <td>{[0, 1, 2, 3].map(n => formatRangeNumber((idx + 1) * 4 - (3 - n))).join("-")}</td>
                                </tr>)}
                            </tbody>
                        </table>
                    </div>
                    <hr className="as_hr_line" />
                    <h2 className="AS_box_headers">Payout Table</h2>
                    <div className="AS_payTable">
                        <table className="AS_payTable">
                            <thead className="AS_payTable_head">
                                <tr>
                                    <th>Win</th>
                                    <th>Prize</th>
                                </tr>
                            </thead>
                            <tbody className="AS_payTable_body">
                                {props.game_PayoutInfo?.map((ele, idx) => <tr>
                                    <td>{ele.key}</td>
                                    <td>{ele.value}</td>
                                </tr>)}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
})

export default AnimalSoratGameOptions